import type { OperationMessage } from "@onesolution/monday/queries/operationDetails.graphql";

const adminEmail = import.meta.env.VITE_PUBLIC_ADMIN_EMAIL;

export default function parseMessageForNotif(message: OperationMessage) {
	if (message.text_body.startsWith("{front}")) return null;

	const fromFront = /^[^@\s]+@[^@\s]+\s+.+$/.test(
		message.text_body.split("\n")[0],
	);

	const fromEmail = fromFront
		? message.text_body.match(/^\[([^\]]+)\]/)?.[1] || message.creator.email
		: message.creator.email;

	const fromName = fromFront
		? message.text_body.match(/^\[[^\]]+\]\s*\[([^\]]+)\]/)?.[1] || fromEmail
		: message.creator.email;

	const txt = (
		fromFront
			? message.text_body.split("\n").slice(1).join("\n")
			: message.text_body.replace(`@${adminEmail}`, "")
	).trim();

	return { fromFront, fromEmail, fromName, txt };
}
